import generatePath from '@utils/generatePath';
import classnames from 'classnames';
import useResizeObserver from 'hooks/use-resize-observer';
import { useTranslation } from 'hooks/use-translation';
import React, { FC, useMemo } from 'react';
import { NavLink } from 'react-router-dom';
import styles from './styles.scss';

const ClassRoomSection: FC = () => {
	const { width } = useResizeObserver();
	const { t, transData, list } = useTranslation('home.classroom');
	const itemList = useMemo(() => {
		if (!Array.isArray(list)) return [];
		return (list as any[]).map((item, index) => {
			return (
				<div className={classnames(styles['ac-classroom-item'], styles[`ac-classroom-item-${item.id}`])} key={index}>
					<NavLink to={generatePath(item.link)}>
						<img loading="lazy" src={width >= 1192 ? item.img[0] : item.img[1]} alt="" />
						<div className={styles['ac-classroom-item-content']}>
							<h2>{item.title}</h2>
							<p>{item.content}</p>
							<img className={styles['item-icon']} loading="lazy" src={item.icon} alt="" decoding="async" />
						</div>
					</NavLink>
				</div>
			);
		});
	}, [list]);

	return (
		<section className={styles['ac-classroom']}>
			<div className={styles['ac-classroom-container']}>
				<div dangerouslySetInnerHTML={{ __html: transData.title }} />
				<div className={styles['ac-classroom-list']}>{itemList}</div>
			</div>
		</section>
	);
};

export default ClassRoomSection;
